export default __webpack_public_path__ + "static/media/cp_cp_checkpoint.0207c036.svg";